export const useFormStatus = () => {
  const { t } = useI18n()

  const checkFormClosed = (isClosed?: boolean, basePath?: string) => {
    if (isClosed) {
      showError({
        status: 403,
        statusText: t('form-close-message'),
        data: {
          title: t('error-closed.title'),
          text: t('form-close-message'),
          buttonText: t('form-close-home-link'),
          buttonUrl: `/${basePath || ''}`,
        },
      })
    }
  }

  return {
    checkFormClosed,
  }
}
